interface SIPMosaicDragLayerProps {
  tileTitle: string | null;
  cursor: { x: number; y: number } | null;
}

export function SIPMosaicDragLayer({ tileTitle, cursor }: SIPMosaicDragLayerProps) {
  if (!tileTitle || !cursor) {
    return null;
  }

  return (
    <div
      className="sip-mosaic-drag-layer"
      style={{ transform: `translate(${cursor.x + 12}px, ${cursor.y + 12}px)` }}
    >
      {tileTitle}
    </div>
  );
}
